<template>
  <div class="magezine">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item><strong>会刊信息</strong></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="formSpan">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="magezineForm" :label-position="labelP" size="small" :label-width="labelW">
          <el-form-item label="上传公司LOGO：" prop="clgLogo">
            <!--<el-input v-model="form.clgLogo" style="display:none"></el-input>
            <Upload :mediaUrl.sync="form.clgLogo" />-->
            <div>
              <UploadHeadImg @getFormdata="getFormdata" :mediaUrl.sync="form.clgLogo"></UploadHeadImg>
            </div>
            <p style="font-size: 12px; color: red; padding-left: 5px;">logo尺寸200*200，图片JPG或PNG格式</p>
          </el-form-item>
          <el-form-item label="公司中文名称：" prop="clgComName">
            <el-input v-model="form.clgComName" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="公司英文名称：" prop="clgComEName">
            <el-input v-model="form.clgComEName" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="展位号：" prop="clgBthCode">
            <!-- <el-input v-model="form.clgBthCode" maxlength="100" :disabled=" true"></el-input> -->
            <div :style="{'text-align': exNoP}">{{ userInfo.bthCode || '暂无' }}</div>
          </el-form-item>
          <el-form-item label="公司简介(中文)：" prop="clgIntro">
            <el-input type="textarea" maxlength="500" rows="4" show-word-limit v-model="form.clgIntro"></el-input>
          </el-form-item>
          <!--<el-form-item label="公司类型：" prop="clgComType">
            <el-select v-model="form.clgComType" placeholder="请选择">
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="公司类型：" prop="clgComType">
            <el-checkbox-group v-model="form.clgComType">
              <el-checkbox v-for="(value,index) in options" :label="value" @change="chooseEAddress1(value)" :key="index"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="主营产品：" prop="clgBrand">
            <!-- <el-input v-model="form.clgBrand" maxlength="100"></el-input> -->
            <!--<el-checkbox-group v-model="form.clgBrand">-->
              <div v-for="(value,index) in options3" :key="index">
                <el-checkbox :label="value.name" @change="chooseBrand(value)" v-model="value.show" style="display:block"></el-checkbox>
                <div v-for="(valueChildren,inInder) in value.children" :key="inInder" style="margin-left:24px;display: inline-block;" v-show="value.show">
                  <el-checkbox :label="valueChildren.name" @change="changPro(value)" v-model="valueChildren.show"></el-checkbox>
                  <el-input style="width: 200px; margin-left: 5px;" v-if="valueChildren.name == '其他面料' || valueChildren.name == '其他辅料'" v-model="valueChildren.itxt" :disabled="!valueChildren.show" ></el-input>
                </div>
              </div>
             
            <!--</el-checkbox-group>-->


          </el-form-item>
          <!--<el-form-item class="noRequire" label="主营产品：" prop="clgBoard ">
            <el-input v-model="form.clgBoard " maxlength="100"></el-input>
          </el-form-item>-->
          <el-form-item label="销售类型：" prop="clgEAddress">
            <!-- <el-select v-model="form.clgEAddress" placeholder="请选择">
              <el-option
                v-for="(item, index) in options1"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select> -->
            <el-checkbox-group v-model="form.clgEAddress">
              <el-checkbox v-for="(value,index) in options1" :label="value" @change="chooseEAddress(value)" :key="index"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="国家城市：" prop="countryString">
            <el-input v-model="form.countryString" style="display:none"></el-input>

            <el-row :gutter="20">
              <el-col :span="selSpn" class="col-1-fix">
                <el-select class="el-select11" style="float:right;" v-model="form.clgCountry" placeholder="请选择" @change='changeCountry'>
                  <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                </el-select>
              </el-col>
              <el-col :span="selSpn" class="col-1-fix" v-show="form.clgCountry == '中国'" >
                <el-select class="el-select11" v-model="form.clgProvince" placeholder="请选择" @change='changeProvince'>
                  <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                </el-select>
              </el-col>
              <el-col :span="selSpn" class="pad0" v-show="form.clgCountry == '中国'">
                <el-select class="el-select11" v-model="form.clgCity" placeholder="请选择" @change="changeCity">
                  <el-option v-for="(item, index) in cityList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="公司地址：" prop="clgAddress">
            <el-input v-model="form.clgAddress" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="网址：" prop="clgWebUrl">
            <el-input v-model.trim="form.clgWebUrl"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="电话：" prop="clgTel">
            <el-input v-model.trim="form.clgTel" maxlength="100"></el-input>
          </el-form-item>
          <!--<el-form-item class="noRequire" label="英文地址：" prop="clgEAddress">
            <el-input v-model="form.clgEAddress" maxlength="100"></el-input>
          </el-form-item>-->
          <!--<el-form-item class="noRequire" label="传真：" prop="clgFax">
            <el-input v-model.trim="form.clgFax" maxlength="100"></el-input>
          </el-form-item>-->
          
          <!--<el-form-item label="电话：" ref="cccItem" class="cccItem" prop="clgTel">
            <el-input v-model="form.clgTel" style="display:none"></el-input>
            <el-row :gutter="20" v-if="isPC">
              <el-col :span="4" class="col-1-fix"><el-input v-model.trim="form.clgTel_1" @keyup.native="inputChange($event,'clgTel_1')" @input="changeInput($event,'clgTel')" ></el-input></el-col>
              <el-col :span="4"><el-input v-model.trim="form.clgTel_2"  @keyup.native="inputChange($event,'clgTel_2')" @input="changeInput($event,'clgTel')"></el-input></el-col>
              <el-col :span="8"><el-input v-model.trim="form.clgTel_3"  @keyup.native="inputChange($event,'clgTel_3')" @input="changeInput($event,'clgTel')"></el-input></el-col>
              <el-col :span="4"><el-input v-model.trim="form.clgTel_4"  @keyup.native="inputChange($event,'clgTel_4')" @input="changeInput($event,'clgTel')" class="clearError"></el-input></el-col>
            </el-row>
          </el-form-item>-->
          <div v-if="!isPC" style="overflow:hidden;" class="telOrFax">
            <el-col :span="4" class="col-1-fix"><el-input v-model.trim="form.clgTel_1" @keyup.native="inputChange($event,'clgTel_1')" @input="changeInput($event,'clgTel')" ></el-input></el-col>
            <el-col :span="5"><el-input v-model.trim="form.clgTel_2"  @keyup.native="inputChange($event,'clgTel_2')" @input="changeInput($event,'clgTel')"></el-input></el-col>
            <el-col :span="10"><el-input v-model.trim="form.clgTel_3"  @keyup.native="inputChange($event,'clgTel_3')" @input="changeInput($event,'clgTel')"></el-input></el-col>
            <el-col :span="5"><el-input v-model.trim="form.clgTel_4"  @keyup.native="inputChange($event,'clgTel_4')" @input="changeInput($event,'clgTel')" class="clearError"></el-input></el-col>
          </div>
          <!--<el-form-item label="传真：" ref="cccItem" class="cccItem" prop="clgFax">
            <el-row :gutter="20" v-if="isPC">
              <el-col :span="4" class="col-1-fix"><el-input v-model.trim="form.clgFax_1" ref="clgFax_1"  @keyup.native="inputChange($event,'clgFax_1')"  @input="changeInput($event,'clgFax')"></el-input></el-col>
              <el-col :span="4"><el-input v-model.trim="form.clgFax_2"   ref="clgFax_2" @keyup.native="inputChange($event,'clgFax_2')" @input="changeInput($event,'clgFax')"></el-input></el-col>
              <el-col :span="8"><el-input v-model.trim="form.clgFax_3"   ref="clgFax_3" @keyup.native="inputChange($event,'clgFax_3')" @input="changeInput($event,'clgFax')"></el-input></el-col>
              <el-col :span="4"><el-input v-model.trim="form.clgFax_4"   ref="clgFax_4"  @keyup.native="inputChange($event,'clgFax_4')" @input="changeInput($event,'clgFax')" class="clearError"></el-input></el-col>
            </el-row>
          </el-form-item>-->
          <div v-if="!isPC" style="overflow:hidden;" class="telOrFax">
            <el-col :span="4" class="col-1-fix"><el-input v-model.trim="form.clgFax_1" ref="clgFax_1"  @keyup.native="inputChange($event,'clgFax_1')"  @input="changeInput($event,'clgFax')"></el-input></el-col>
            <el-col :span="5"><el-input v-model.trim="form.clgFax_2"   ref="clgFax_2" @keyup.native="inputChange($event,'clgFax_2')" @input="changeInput($event,'clgFax')"></el-input></el-col>
            <el-col :span="10"><el-input v-model.trim="form.clgFax_3"   ref="clgFax_3" @keyup.native="inputChange($event,'clgFax_3')" @input="changeInput($event,'clgFax')"></el-input></el-col>
            <el-col :span="5"><el-input v-model.trim="form.clgFax_4"   ref="clgFax_4"  @keyup.native="inputChange($event,'clgFax_4')" @input="changeInput($event,'clgFax')" class="clearError"></el-input></el-col>
          </div>
          <el-form-item class="noRequire" label="联系人：" prop="clgLinkMan">
            <el-input v-model.trim="form.clgLinkMan" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="手机：" prop="clgMobile">
            <el-input v-model.trim="form.clgMobile" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="邮件：" prop="clgEmail">
            <el-input v-model.trim="form.clgEmail"></el-input>
          </el-form-item>
          <!--<el-form-item label="展品：" prop="clgPdtType">
            <el-input v-model.trim="form.clgPdtType" placeholder="（多个展品请用'、'分隔）"></el-input>
          </el-form-item>
          <el-form-item label="展品：" prop="clgPdtType" style="display: none;">
            <el-cascader v-model="form.clgPdtType" :options="tagOptions" :props="tagProps" separator="：" clearable  ></el-cascader>
          </el-form-item>-->
          <el-form-item label="成品是否支持特殊尺码：" prop="clgEIntro">
            <el-select v-model="form.clgEIntro" placeholder="请选择">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <!--
          <el-form-item class="noRequire" label="公司英文介绍：" prop="clgEIntro">
            <el-input type="textarea" maxlength="200" rows="4" show-word-limit v-model="form.clgEIntro"></el-input>
          </el-form-item>

          <el-form-item label="展品(中文)：" prop="clgPdtIntro">
            <el-input v-model="form.clgPdtIntro" placeholder="（多个展品请用'、'分隔）"></el-input>
          </el-form-item>

          <el-form-item label="展品(英文)：" prop="clgPdtEIntro">
            <el-input v-model="form.clgPdtEIntro" placeholder="（多个展品请用'、'分隔）"></el-input>
          </el-form-item>
          
          <el-divider></el-divider>
          <h3 class="title blue">联系方式</h3>

          <el-form-item label="邮编：" prop="clgZipCode">
            <el-input v-model="form.clgZipCode"></el-input>
          </el-form-item>
 -->
          <el-form-item>
            <el-button type="primary" @click="onSubmit" :disabled = 'saveBtnStatue'>提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../utils/tools.js'
import UploadHeadImg from '@/components/cropper.vue'
import { validateEnName, validateEnCompany, validateChineseZipCode, validateEmail,validateCoutry,validateMobile,validateTel,validateFax} from '@/utils/validator'
export default {
  data: () => ({
    name: 'ClientHome',
    userInfo: JSON.parse(localStorage.getItem('userInfo')),
    tagProps: {
      multiple: true,
      label: 'name',
      value: 'id',
      children: 'childs'
    },
    saveBtnStatue:false,  //保存铵钮状态
    tagOptions: [],
    countryList: [],    //国家
    provinceList: [],  //省份
    cityList: [],    //城市
    form: {
      clgLogo:"",
      countryString:"",
      clgID:0,
      clgComName:"",
      clgComEName:"",
      clgBthCode:JSON.parse(localStorage.getItem('userInfo')).bthCode,
      clgIntro:"",
      clgEIntro:"",
      clgComType:[],
      clgPdtType:"",
      clgPdtIntro:"",
      clgPdtEIntro:"",
      clgAddress:"",
      clgEAddress:[],
      clgCountry:"",
      clgProvince:"",
      clgBoard:"",
      clgTel:"",
      clgTel_1:"",
      clgTel_2:"",
      clgTel_3:"",
      clgTel_4:"",
      clgFax:"",
      clgFax_1:"",
      clgFax_2:"",
      clgFax_3:"",
      clgFax_4:"",
      clgCity:"",
      clgZipCode:"",
      clgEmail:"",
      clgWebUrl:"",
      clgMobile:"",
      clgLinkMan:"",
      clgBrand:[]
    },
    rules: {
      clgLogo: [{ required: true, message: '请上传公司logo', trigger: 'blur' }],
      clgComName: [{ required: true, message: '请填写公司名称', trigger: 'blur' ,transform: value => value ? value.trim() : ''}],
      clgBthCode: [{ required: true, message: '',}],
      clgComEName: [
        {
          required: true,
          validator: validateEnCompany,
          message: '只能输入英文字母和英文符号',
          trigger: 'blur',
          transform: value => value ? value.trim() : ''
        }
      ],
      clgIntro: [{ required: true, message: '中文介绍不能为空', trigger: 'blur' ,}],
      clgComType: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
      clgEIntro: [{ required: true, message: '主营产品不能为空', trigger: 'blur' }],
      clgWebUrl: [{ required: true, message: '网址不能为空', trigger: 'blur' }],
      clgAddress: [{ required: true, message: '中文地址不能为空', trigger: 'blur' }],
      clgEAddress: [{ required: true, message: '请选择销售类型', trigger: 'blur' }],
      clgBrand: [{ required: true, message: '请选择主营产品', trigger: 'blur' }],
      countryString: [{ required: true, message: '国家不能为空', trigger: 'blur' },
          {
            validator: validateCoutry,
            message: '',
            trigger: 'blur'
          }
        ],
      clgZipCode: [
        { required: true, message: '邮编不能为空', trigger: 'blur' },
        {
          validator: validateChineseZipCode,
          message: '邮编格式不正确',
          trigger: 'blur'
        }
      ],
      clgLinkMan: [{ required: true, message: '联系人必填', trigger: 'blur' },
              {
                validator: validateEnName,
                message: '联系人格式不正确',
                trigger: 'blur'
              }
            ],
      clgMobile: [{ required: true, message: '手机必填', trigger: 'blur' },
              {
                validator: validateMobile,
                message: '手机格式不正确',
                trigger: 'blur'
              }
            ],
      clgTel: [{ required: true, message: '联系方式必填', trigger: 'blur' },
              {
                validator: validateTel,
                message: '联系方式格式不正确',
                trigger: 'blur'
              }
            ],		
            
      clgFax: [{ required: true, message: '传真必填', trigger: 'blur' },
              {
                validator: validateFax,
                message: '传真格式不正确，例：86-010-1234567',
                trigger: 'blur'
              }
            ],

      clgEmail: [
        { required: true, message: '电子邮件必填', trigger: 'blur' },
        {
          validator: validateEmail,
          message: '电子邮件格式不正确',
          trigger: 'blur'
        }
      ]
    },
    isPC: true,
    formSpan: 18,
    labelW: '240px',
    labelP: 'right',
    selSpn: 7,
    exNoP: 'left',
    options: ['OEM','ODM企业','经销','代理','贸易公司','品牌商','生产制造'],
    options1: ['出口','内销','线上','线下','套装销售','接受小订单','生产制造'],
    options2: ['是','否'],
    options3: [
      {
        name:'内衣',
        show:false,
        children:[
          {name:"文胸",show:false},{name:"塑身内衣",show:false},{name:"功能内衣",show:false},{name:"保暖内衣",show:false},{name:"保健内衣",show:false},{name:"哺乳内衣",show:false},{name:"无痕内衣",show:false},{name:"少女内衣",show:false},{name:"性感内衣",show:false},{name:"贴胶内衣",show:false},{name:"无缝内衣",show:false},{name:"针织内衣",show:false},{name:"儿童内衣",show:false},{name:"男士内衣",show:false},{name:"内衣设计",show:false},{name:"胸贴",show:false}
        ]
      },
      {
        name:'内裤',
        show:false,
        children:[
          {name:"女士内裤",show:false},{name:"男士内裤",show:false},{name:"儿童内裤",show:false},{name:"孕妇内裤",show:false},{name:"蕾丝内裤",show:false},{name:"无痕内裤",show:false},{name:"无缝内裤",show:false},{name:"车缝内裤",show:false}
        ]
      },
      {
        name:'家居',
        show:false,
        children:[
          {name:"家居服",show:false},{name:"生活装",show:false},{name:"睡衣",show:false},{name:"月子服",show:false},{name:"婴儿服",show:false},{name:"保暖",show:false},{name:"打底",show:false},{name:"背心",show:false},{name:"袜子",show:false},{name:"毛巾",show:false},{name:"拖鞋",show:false}
        ]
      },
      {
        name:'休闲运动',
        show:false,
        children:[
          {name:"运动瑜伽服",show:false},{name:"暴汗服",show:false},{name:"防晒服",show:false},{name:"防晒袖套",show:false},{name:"泳装",show:false},{name:"沙滩装",show:false},{name:"塑身美体",show:false}
        ]
      },
      {
        name:'面料',
        show:false,
        children:[
          {name:"纯棉",show:false},{name:"莱卡",show:false},{name:"莫代尔",show:false},{name:"尼龙",show:false},{name:"真丝",show:false},{name:"蕾丝",show:false},{name:"花边",show:false},{name:"刺绣",show:false},{name:"网布",show:false},{name:"经编",show:false},{name:"其他面料",show:false,itxt:''}
        ]
      },
      {
        name:'辅料',
        show:false,
        children:[
          {name:"肩带",show:false},{name:"罩杯",show:false},{name:"拉链",show:false},{name:"织带",show:false},{name:"腰头",show:false},{name:"丈根",show:false},{name:"纽扣",show:false},{name:"捆条",show:false},{name:"车缝线",show:false},{name:"配饰配件",show:false},{name:"粘合剂",show:false},{name:"内衣插片",show:false},{name:"其他辅料",show:false,itxt:''}
        ]
      },
      {
        name:'设备',
        show:false,
        children:[
          {name:"裁剪设备",show:false},{name:"缝制设备",show:false},{name:"生产设备",show:false},{name:"纺织设备",show:false},{name:"松紧带设备",show:false},{name:"压模杯设备",show:false},{name:"贴合设备",show:false},{name:"染整设备",show:false},{name:"对色设备",show:false},{name:"验布机",show:false}
        ]
      },
      {
        name:'行业服务',
        show:false,
        children:[
          {name:"专业市场",show:false},{name:"媒体",show:false},{name:"摄影机构",show:false}
        ]
      }

    ],
    // options3: ['文胸','塑身内衣','功能内衣','保暖内衣','保健内衣','哺乳内衣','无痕内衣','少女内衣','性感内衣','贴胶内衣','无缝内衣','针织内衣','儿童内衣','男士内衣','内衣设计'],
    loading: false,
    imgSrc : '',
    fileType: '',
    arr: [],

  }),
	watch: {
		options3:{
			handler(newval){
				this.form.clgBrand = this.dealPro()
			},
			deep: true
		}
	},
  components: {
    UploadHeadImg
  },
  async mounted() {
    this.isPC = tools.isPC()
    if(!this.isPC) {
      this.formSpan= 24;
      this.labelW = '150px'
      this.labelP = 'left'
      this.selSpn = 22
      this.exNoP = 'right'
    }
    api.getallcountrys().then((res) => {      
      this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
    })
    api.getallprovinces().then((res) => {
      this.provinceList = res.data.data
    })
    this.getCity()
    var _data =  await this.getData()
    this.getStype(_data)
  },
  methods: {
    changPro(parent) {
      parent.show = parent.children.some(item => {
        return item.show
      })
    },
    chooseEAddress(id){
      // console.log(id)
      // if(this.arr.indexOf(id)==-1){
      //   this.arr.push(id)
      // }else{
      //   this.arr.splice(this.arr.indexOf(id), 1); 
      // }
      // this.form.clgEAddress=this.arr.join(',')
      // console.log(this.form.clgEAddress,'1111111111111111111')
    },
    chooseEAddress1(id){
    },
    chooseBrand(data){
      data.children.map(item => {
        item.show = data.show
      })
      // console.log(this.form.clgBrand,'1111111111111111111')
    },
    getFormdata(v){
//    console.log(v); // 子组件自定义事件传过来的formData，后续用来上传到后端
      var suffix = '.' + v.fileType;
//    console.log(suffix)
      const params = {
        suffix:suffix,
        exhId: '3111',
        type: 'C',
        base64: v.imgSrc
      }
      api.uploadimage1(params).then(res => {
        if(res.data.code == '200'){
          var _url = res.data.data.url
          this.imgSrc = _url
          this.form.clgLogo = _url
        }else{
          this.$message.error('图片上传失败')
        }
      }).finally(() => {
        this.loading = false
      })
      this.loading = false
    },
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    //电话输入框改变时
    changeInput(ev,str){
        this.getTel(str)
    },
    getClass(arr,val){
      var temp = [];
      function getSelectVal(_arr,_id){
        for(var i=0;i<_arr.length;i++){
          if(_arr[i].childs && _arr[i].childs.length>0){
              getSelectVal(_arr[i].childs,_id)
          }
          if(_arr[i].id == _id){
            var _temp = []
            if(_arr[i].gpId){
              _temp.push(_arr[i].gpId)
            }
            if(_arr[i].pId){
              _temp.push( parseInt(_arr[i].pId))
            }
            _temp.push(_arr[i].id)
            temp.push(_temp)
          }
        }
      }
      getSelectVal(arr,val)
      return temp
    },

    //获取主营产品分类  并且赋值
    // getStype(val){
    //   api.getexhibitstype().then((res) => {
    //     this.tagOptions = this.removeEmptyChild(res.data.data)
    //     var select = []
    //     if(val && val !='' ){
    //         select = val.split(",")
    //     }
    //     if(select.length>0){
    //       var _temp = []
    //       for(var j=0;j<select.length;j++){
    //         _temp.push( ...this.getClass(this.tagOptions,select[j]) )
    //       }
    //       this.form.clgPdtType =  _temp
    //     }
    //   })
    // },
    //国家切换
    changeCountry(){
        if(this.form.clgCountry !='中国'){
            this.form.clgProvince= ''
            this.form.clgCity =''
            this.cityList =[]
        }
        this.getCountry()
    },
    //切换省份
    changeProvince(){
      this.form.clgCity =''
      this.getCity()
      this.getCountry()
    },
    //切换城市
    changeCity(){
      this.getCity()
      this.getCountry()
    },
    //跟据省份获取城市
    getCity(){
      if( this.form.clgProvince && this.form.clgProvince !=""){
          api.getallcitysbyprovince({zptProvince:this.form.clgProvince}).then((res)=>{
              this.cityList = res.data.data
          })
      }else{
          this.cityList = []
      }
    },
    //获取会刊信息
    getData(){
      return new Promise((resolve, reject)=>{
            api.getcatalogdetail().then((res)=>{
                if(res.data.code == 200){
                      var _data = res.data.data
                      this.form.clgLogo = _data.clgLogo
                      this.form.clgID = _data.clgID
                      this.form.clgComName = _data.clgComName
                      this.form.clgComEName = _data.clgComEName
                      this.form.clgIntro = _data.clgIntro
                      this.form.clgComType = _data.clgComType.split(',') //公司类型
                      this.form.clgBrand = _data.clgBrand.split(',')  //
                      this.form.clgEIntro = _data.clgEIntro //
                      this.form.clgPdtType=_data.clgPdtType
                      this.form.clgPdtIntro = _data.clgPdtIntro
                      this.form.clgPdtEIntro = _data.clgPdtEIntro
                      this.form.clgAddress = _data.clgAddress
                      this.form.clgEAddress = _data.clgEAddress.split(',') //销售类型
                      this.form.clgEmail = _data.clgEmail
                      this.form.clgWebUrl = _data.clgWebUrl
                      this.form.clgZipCode = _data.clgZipCode
                      this.form.clgBoard = _data.clgBoard  
                      this.form.clgCountry = _data.clgCountry
                      this.form.clgProvince = _data.clgProvince
                      this.form.clgCity = _data.clgCity
                      this.form.clgMobile = _data.clgMobile
                      this.form.clgTel = _data.clgTel
                      this.form.clgLinkMan = _data.clgLinkMan
//                    this.form.clgFax = _data.clgFax
                      
                      var _clgTel = _data.clgTel ?  _data.clgTel.split("-") :""
                      this.setTel('clgTel',_clgTel)

//                    var _clgFax = _data.clgFax ? _data.clgFax.split("-") :""
//                    this.setTel('clgFax',_clgFax)
 
                      this.getCountry()
                      api.getallcountrys().then((res) => {      
                        this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
                      });
                      api.getallprovinces().then((res) => {
                        this.provinceList = res.data.data
                      });
                      this.getCity()
                      let tmpArro = []
                      let qtml = ''
                      let qtfl = ''
                      this.form.clgBrand.map(item => {
                        if(item.indexOf(':')>-1){
                          tmpArro = item.split(':')
                          this.form.clgBrand.push(tmpArro[0])
                          if(tmpArro[0] === '其他面料') {
                            qtml = tmpArro[1]
                          }
                          if(tmpArro[0] === '其他辅料') {
                            qtfl = tmpArro[1]
                          }
                        }
                      })
                      this.$nextTick(()=>{
												for(var j=0;j<this.options3.length;j++){
													this.options3[j].show = this.form.clgBrand.indexOf(this.options3[j].name)>-1
													this.options3[j].children.map(item => {
														item.show = this.form.clgBrand.indexOf(item.name)>-1
														if(item.name === '其他面料') {
                              item.itxt = qtml
														}
														if(item.name === '其他辅料') {
                              item.itxt = qtfl
														}
													})
												}
											})
                      // resolve(_data.clgPdtType)
                }else{
                  reject("")
                }
            })
      })
    },
    //获取国家字符串  用于判断国家 省份 城市 是否选择
    getCountry(){
//      api.getallcountrys().then((res) => {      
//        this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
//      })
//      api.getallprovinces().then((res) => {
//        this.provinceList = res.data.data
//      })
        this.form.countryString =  this.form.clgCountry !=''  ? this.form.clgCountry  :""
        this.form.countryString +=  this.form.clgProvince !='' ? ( "-" + this.form.clgProvince)  :"" 
        this.form.countryString +=  this.form.clgCity !='' ? ( "-" +this.form.clgCity  ) :"" 
    },
    //获取电话字符串
    getTel(str){
        this.form[str] = ''
        for(var i=1;i < 5;i++){
          if( this.form[str+"_"+i] !='' ){
            this.form[str]  +=this.form[str+"_"+i] + (i < 4 ? "-" : "")
          }else{
             this.form[str] =  this.form[str].substring(0,this.form[str].length-1)
            return false
          }
        }
    },
    //给电话赋值
    setTel(str,arr){
        for(var i=0;i < arr.length;i++){
          this.form[str+"_" + (i+1)] = arr[i]
        }
    },
    
    dealPro() {
      const tmpArrs = []
      this.options3.forEach(item => {
        if (item.show){
          tmpArrs.push(item.name)
          item.children.forEach(item2 => {
            if (item2.show){
              if(item2.name === '其他面料' || item2.name === '其他辅料') {
                tmpArrs.push(`${item2.name}:${item2.itxt}`)
              } else {
                tmpArrs.push(item2.name)
              }
            }
          })
        }
      })
      return tmpArrs
    },
    onSubmit() {
        if( this.saveBtnStatue ){
          return false
        }
        this.$refs['magezineForm'].validate((valid) => {
          if (valid) {
              if(this.options3[4].children[10].show == true && this.options3[4].children[10].itxt == ''){
                  this.$notify({
                    title: '请输入其他面料',
                    type: 'error',
                    duration: 2000,
                    position: 'bottom-right',
                    offset: 100
                  })
                  return
              }
              if(this.options3[5].children[12].show == true && this.options3[5].children[12].itxt == ''){
                  this.$notify({
                    title: '请输入其他辅料',
                    type: 'error',
                    duration: 2000,
                    position: 'bottom-right',
                    offset: 100
                  })
                  return
              }
              let tmpArrs = this.dealPro()
              var paramt = JSON.parse(JSON.stringify(this.form))
              // alert(JSON.parse(JSON.stringify(this.form)).clgID)
              var _clgFax =  paramt.clgFax ? paramt.clgFax.split("-") : []
//               if( _clgFax.length >0 && _clgFax.length<3 ){
//                   this.$notify({
//                     title: '警告',
//                     message: '请填写完整传真',
//                     type: 'warning',
//                       duration: 2000
//                   });
// 
//                   this.$refs['clgFax_'+ (_clgFax.length+1)].focus()
//                   return false
//               }

//               var tempArry = []
//               for(var i=0;i<paramt.clgPdtType.length;i++){
//                 var _arr = paramt.clgPdtType[i]
//                 tempArry.push( _arr[_arr.length-1])
//               }
// 
//               paramt.clgPdtType = tempArry.join(",")
//            console.log(paramt.clgEAddress)
              
              paramt.clgComType = paramt.clgComType.join(',')
							paramt.clgEAddress = paramt.clgEAddress.join(',')
							paramt.clgBrand = tmpArrs.join(',')  //
              this.saveBtnStatue = true
              api.savecatalog(paramt).then((res) => {
                if (res.data.code === 200) {
                  this.$notify({
                    title: '提交成功',
                    type: 'success',
                    duration: 2000,
                    position: 'bottom-right',
                    offset: 100
                  })
                }
                this.saveBtnStatue = false
              })
          } else {
            return false
          }
        })
    },

    // 因后端API不支持，需前端处理数据结构，仅支持三级，写死去掉最后childs为空的属性
    removeEmptyChild(data) {
      let types = data.map((element) => {
        if (element.childs.length === 0) {
          delete element.childs
        } else {
          element.childs.map((item) => {
            if (item.childs.length === 0) {
              delete item.childs
            } else {
              item.childs.map((_item) => {
                if (_item.childs && _item.childs.length === 0) {
                  delete _item.childs
                }
                return _item
              })
            }
            return item
          })
        }
        return element
      })
      return types
    }
  }
}
</script>
<style lang="less">
.magezine{
  .el-form-item.is-error .clearError input.el-input__inner{
    border: 1px solid #DCDFE6 !important;
  }
  .blue {
    color: #409eff;
  }

  .title {
    margin-bottom: 30px;
  }

  .col-1-fix {
    padding-left: 0 !important;
    margin-right: 5.5%;
  }
  .pad0{
      padding-left: 0 !important;
      padding-right:0 !important;
    }
  .el-upload img{
    height: 200px !important; width: 200px !important;
  }
  .el-select11{
    width: 100% !important;
  }
}
.el-breadcrumb{
	font-weight: bold !important;
	font-size: 16px;
}
@media screen and (max-width:540px){
  .magezine{
    .el-form-item__error{
      width: 100%;
      text-align: right;
    }
    .el-form-item__label{
      font-size:14px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .cccItem{
      border:0;
      margin:0;
      .el-form-item__error{
        top: 240%
      }
    }
    .pad0{
      padding-left: 0 !important;
      padding-right:0 !important;
    }
    .telOrFax{
      padding:0 24px;
      .el-input__inner{
        padding:0;
        border: 1px solid #ededed;
        text-align: center;
      }
    }
    .el-upload img{
      height: auto !important; width: auto !important;
    }
  }
}
</style>
